import React from 'react';
import Link from 'next/link';
import NextSteps from 'components/NextSteps';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import SalesCalloutHTO from 'components/SalesCalloutHTO';
import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import { withPageStaticProps } from 'utils/header';

class CCPA extends React.Component {
  render() {
    return (
      <>
        <Layout1x1 className="m-section-hero">
          <h1 className="text-h1-display">Your California Privacy Rights</h1>

          <Line />

          <p>
            If you are a California resident, under California law, including the California Consumer Privacy Act
            (CCPA), you have the rights outlined in this section. If there are any conflicts between this section and
            any other provision of this Privacy Policy and you are a California resident, the portion that is more
            protective of Personal Information shall control to the extent of such conflict. If you have any questions
            about this section or whether any of the following applies to you, please contact us via phone at
            1-844-726-4889 or via email at{' '}
            <Link href="mailto:&#099;&#099;&#112;&#097;&#064;&#103;&#101;&#110;&#101;&#114;&#097;&#116;&#105;&#111;&#110;&#116;&#117;&#120;&#046;&#099;&#111;&#109;">
              <a className="tracker-text-ccpa-mailto-top-20191218-165938">ccpa@generationtux.com</a>
            </Link>
            .
          </p>

          <p>
            For purposes of exercising your rights below, please note the following regarding how we collect and use
            your Personal Information as described in this Privacy Policy:
          </p>

          <p>
            The following details the categories of Personal Information that we collect and have collected over the
            past twelve (12) months: Personal Identifiers, including name, shipping address, email, phone, customer
            support inquiries, browsing history on our site, and fit information; customer records identified by state
            law (including the California Customer Records statute (Cal. Civ. Code § 1798.80(e)); Demographic
            Information and Protected Classification Characteristics, including protected classification characteristics
            under state or federal law; Information you Submitted or Posted; Commercial Information; Device Information;
            Location Information and Internet or Other Network Activity Information, including Geolocation Data;
            Customer Service Information; and Inferences.
          </p>

          <p>
            Over the past twelve (12) months, we have NOT disclosed the following categories of Personal Information to
            service providers or other parties for business purposes: Personal Identifiers, including name, shipping
            address, email, phone, customer support inquiries, browsing history on our site, and fit information; Device
            Information; and Location Information and Internet or other Network Activity Information.
          </p>

          <p>Based on our understanding of the term "sell" under the CCPA, we do not sell your Personal Information.</p>

          <h2 className="text-h2-display">Access</h2>

          <p>
            You have the right to request certain information about our collection and use of your Personal Information
            over the past 12 months. We will provide you with the following information:
          </p>

          <ul>
            <li>The categories of Personal Information that we have collected about you.</li>
            <li>The categories of sources from which that Personal Information was collected.</li>
            <li>The business or commercial purpose for collecting or selling your Personal Information.</li>
            <li>The categories of third parties with whom we have shared your Personal Information.</li>
            <li>The specific pieces of Personal Information that we have collected about you.</li>
          </ul>

          <p>
            If we have disclosed your Personal Information for a business purpose over the past 12 months, we will
            identify the categories of Personal Information shared with each category of third party recipient.
          </p>

          <h2 className="text-h2-display">Removal</h2>

          <p>
            You have the right to request that we delete the Personal Information that we have collected from you. Under
            the CCPA, this right is subject to certain exceptions: for example, we may need to retain your Personal
            Information to provide you with our Services or complete a transaction or other action you have requested.
            If your deletion request is subject to one of these exceptions, we may deny your deletion request.
          </p>

          <h2 className="text-h2-display">Exercising Your Rights</h2>

          <p>
            To exercise the rights described above, you must send us a request that (i) provides sufficient information
            to allow us to verify that you are the person about whom we have collected Personal Information, and (ii)
            describes your request in sufficient detail to allow us to understand, evaluate, and respond to it. Each
            request that meets both of these criteria will be considered a "Valid Request." We may not respond to
            requests that do not meet these criteria. We will only use Personal Information provided in a Valid Request
            to verify you and complete your request. You do not need a Generation Tux account to submit a Valid Request.
          </p>

          <p>
            We will work to respond to your Valid Request within 45 days of receipt. We will not charge you a fee for
            making a Valid Request unless your Valid Request(s) is excessive, repetitive, or manifestly unfounded. If we
            determine that your Valid Request warrants a fee, we will notify you of the fee and explain that decision
            before completing your request.
          </p>

          <p>
            By Telephone: 1-844-726-4889 <br />
            By Email:{' '}
            <Link href="mailto:&#099;&#099;&#112;&#097;&#064;&#103;&#101;&#110;&#101;&#114;&#097;&#116;&#105;&#111;&#110;&#116;&#117;&#120;&#046;&#099;&#111;&#109;">
              <a className="tracker-text-ccpa-mailto-bottom-20191218-165938">ccpa@generationtux.com</a>
            </Link>
          </p>

          <h2 className="text-h2-display">
            We Will Not Discriminate Against You For Exercising Your Rights Under The CCPA
          </h2>

          <p>
            We will not discriminate against you for exercising your rights under the CCPA. We will not deny you our
            goods or services, charge you different prices or rates, or provide you a lower quality of goods and
            services if you exercise your rights under the CCPA. However, we may have different tiers of Services as
            allowed by applicable data protection laws (including the CCPA) with varying prices, rates, attributes or
            levels of quality of the goods or services you receive related to the value of Personal Information that we
            receive from you.
          </p>

          <p>
            See full{' '}
            <Link href="/privacy">
              <a className="tracker-text-ccpa-privacy-policy-20191218-152143">Privacy Policy</a>
            </Link>
            .
          </p>
        </Layout1x1>

        <NextSteps
          ctaPageName="privacy"
          salesCallout1={<SalesCalloutHTO ctaPageName="privacy" />}
          salesCallout2={<SalesCalloutSwatches ctaPageName="privacy" />}
        />
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default CCPA;
